export const userHasAudiencesAccess = (user) => user.shouldShowAudiences();

export const userHasCompaniesAccess = (user) => user.shouldShowCompanies();

export const userHasDashboardAccess = (user) => user.shouldShowDashboard();

export const userHasPeopleAccess = (user) => user.shouldShowPeople();

export const userHasSettingsAccess = (user) => user.shouldShowSettings();

export const userHasSetupAccess = (user) => user.shouldShowSetup();

export const userHasInternalAccess = (user) => user.hasInternalAccess();
